import CargoCompanyCargoTaxiContractsResponse, {
  CargoCompanyCargoTaxiContractsResponseItem,
  CargoCompanyCargoTaxiContractsResponseTaxiCorporation,
} from "../../../../api/raily/cargo-company/cargo-taxi/contracts/cargo-company-cargo-taxi-contracts.response";
import CargoCompanyCargoTaxiContracts, {
  CargoCompanyCargoTaxiContractsItem,
  CargoCompanyCargoTaxiContractsItemTaxiCorporation,
} from "./cargo-company-cargo-taxi-contracts";

const createDataItemTaxiCorporation = (
  taxiCorporation: CargoCompanyCargoTaxiContractsResponseTaxiCorporation,
): CargoCompanyCargoTaxiContractsItemTaxiCorporation => {
  return {
    companyName: taxiCorporation.companyName,
  };
};

const createDataItem = (
  item: CargoCompanyCargoTaxiContractsResponseItem,
): CargoCompanyCargoTaxiContractsItem => {
  return {
    allowChargeDuringRide: item.allowChargeDuringRide,
    allowChargeWhileApproaching: item.allowChargeWhileApproaching,
    allowChargeWhileReturning: item.allowChargeWhileReturning,
    discountLimit: item.discountLimit,
    distanceRate: item.distanceRate,
    haltingTimeAfterMinutes: item.haltingTimeAfterMinutes,
    haltingTimeRate: item.haltingTimeRate,
    id: item.id,
    model: item.model,
    publishingAllowed: item.publishingAllowed,
    taxiCorporation: createDataItemTaxiCorporation(item.taxiCorporation),
    valid: item.valid,
    validSince: item.validSince,
    validTo: item.validTo,
  };
};

const createData = (
  responseData: CargoCompanyCargoTaxiContractsResponseItem[],
): CargoCompanyCargoTaxiContractsItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: CargoCompanyCargoTaxiContractsResponse,
): CargoCompanyCargoTaxiContracts => {
  return createData(response.data);
};

const cargoCompanyCargoTaxiContractsFactory = {
  create,
};

export default cargoCompanyCargoTaxiContractsFactory;
